module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pollMaxAnswers":"Max. {maxAnswers} Antworten möglich","please":"Bitte","doLogin":"einloggen","toVote":"um abzustimmen","sendVote":"Abstimmen"},"en":{"pollMaxAnswers":"choose up to {maxAnswers} answers","please":"Please","doLogin":"login","toVote":"to vote","sendVote":"Vote"}}')
  delete Component.options._Ctor
}
